import { render, staticRenderFns } from "./pack_details.vue?vue&type=template&id=220b5bee&"
import script from "./pack_details.vue?vue&type=script&lang=js&"
export * from "./pack_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports